<template lang="pug">
  .ukraine
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/ukrine-min.png"
      )
      span {{ gettext('Украина') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content.one-grid
      div
        p {{ gettext('Украинцы - это славянская нация, которая проживает в Центрально-Восточной Европе, в большой и живописной стране Украине. Украинцы как нация известны своим радушием, демократичностью, трудолюбием, толерантностью, культом семьи и религиозностью. Украинская нация сформировалась как земледельческая, но, несмотря на это в Украине большое внимание уделяется образованию, еще с давних времен Киевской Руси. Это делает украинцев высоко восприимчивыми к новой информации, любопытными и культурно образованными людьми.') }}
        p {{ gettext('Украинцы имеют несколько многочисленных диаспор по всему миру, наибольшие из которых проживают в Канаде, США, России и Польше. Также украинцы трудятся во многих странах Европы: Германии, Италии, Великобритании, Чехии, Словакии, странах Прибалтики, Португалии и других. В 2017 году ЕС выдала более 3,5 миллиона новых видов на жительство. Наибольшей группой получателей были украинцы. По данным Международной организации по миграции (МОМ), они составляют самую большую долю трудовых мигрантов с высшим образованием. Это свидетельствует о большом потенциале работников и желании работать в Европе.') }}
        p {{ gettext('Среди украинских рабочих много квалифицированных специалистов в сферах строительства, сельского хозяйства, производства, транспорта и технологий, сервиса и здравоохранения. Правительства Чехии, Словакии, Венгрии и Эстонии создали программы вербовки в Украине. Правительство Польши меняет свои законы, чтобы привлечь больше украинцев, дополнительно к 1,3 миллионам, которые уже там работают.') }}
        p {{ gettext('Украинскую рабочую силу характеризируют как недорогую и образованную. На примере польской экономики мы можем также удостоверится в ее эффективности: экономика Польши в 2017 году увеличилась на 4,6% и в настоящее время растет с максимальными темпами с 2011 года. Польше потребуется еще 5 миллионов украинских рабочих в течение следующих 20 лет для поддержания этого экономического роста.') }}
        p {{ gettext('В опросе, проведенном социологической группой «Рейтинги», которая опросила украинцев, работавших в странах ЕС и в России, 19 % были «очень довольны» своей зарплатой, а 62 % были «удовлетворены».') }}
        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/ukrine-min.png'})
  },
  name: 'Ukraine',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Ukraine | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/ukraine/index.vue